import { render, staticRenderFns } from "./AdminSong.vue?vue&type=template&id=165f614b&scoped=true&"
import script from "./AdminSong.vue?vue&type=script&lang=js&"
export * from "./AdminSong.vue?vue&type=script&lang=js&"
import style0 from "./AdminSong.vue?vue&type=style&index=0&id=165f614b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f614b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VSnackbar,VTextarea})
